'use strict';
const RequestManager = require('../helpers/request-manager');
const ParamsManager = require('../helpers/params-manager');
const errorHandler = require('../helpers/error-handler');

class Partner {
  constructor(credentials, request, sdkConfiguration) {
    this.requestManager = new RequestManager(sdkConfiguration, request, credentials);
    this.paramsManager = new ParamsManager();
  }

  byMPN(mpn) {
    this.mpn = mpn;
    return this;
  }

  get() {
    this.validMPN();
    this.requestManager.requestConfigurationManager.setApi('GetPartnerProfile');
    this.paramsManager.addQueryParam({ mpnId: this.mpn });
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  validMPN() {
    if (!this.mpn) {
      throw errorHandler.handleError('To use this function, first use the byMPN function, to set the mpnId');
    }
  }
}

module.exports = Partner;
